export const formatDirectionEnum = (direction) => {
  return direction == "ascend" ? "asc" : "desc";
};

export const unformatDirectionEnum = (direction) => {
  return direction.toLowerCase() == "asc" ? "ascend" : "descend";
};

// Returns a sort order for null values (nulls sort last), or null if neither value is null.
export const compareNullable = (aVal, bVal) => {
  if (aVal == null && bVal == null) {
    return 0;
  }

  if (aVal == null) {
    return 1;
  }

  if (bVal == null) {
    return -1;
  }

  return null;
};

// Compares two non-null values: numbers numerically, everything else as lowercase strings.
export const compareScalars = (aVal, bVal) => {
  if (typeof aVal === "number" && typeof bVal === "number") {
    return aVal - bVal;
  }

  const toStr = (v) => {
    const str = typeof v === "object" ? JSON.stringify(v) : String(v);

    return str.toLowerCase();
  };

  return toStr(aVal).localeCompare(toStr(bVal));
};

export const compareValues = (aVal, bVal, direction) => {
  const nullResult = compareNullable(aVal, bVal);

  if (nullResult !== null) {
    return nullResult;
  }

  const cmp = compareScalars(aVal, bVal);

  return direction === "ascend" ? cmp : -cmp;
};

export const formatSortField = (sortObject) => {
  if (!sortObject || !sortObject.direction) {
    return undefined;
  }

  return `${sortObject.key}_${formatDirectionEnum(
    sortObject.direction,
  ).toUpperCase()}`;
};
